<div class="field-title-wrapper">
  <div class="mandatory-label" 
    *ngIf="!fieldDefinition.is_nullable">
    *
  </div>
  <div class="title">
    {{fieldDefinition.name}}
  </div>
</div>